export default {
  title: 'Dane bankowe',
  sections: {
    personal_info: 'Dane osobowe',
    address: 'Adres',
  },
  labels: {
    account_number: 'Numer konta',
    routing_number: 'Numer rozliczeniowy',
    email: 'E-mail',
    full_name: 'Imię i nazwisko',
    street: 'Adres ulicy',
    zip_code: 'Kod pocztowy',
    city: 'Miasto',
  },
  tooltip: '{{field}} skopiowano do schowka!',
};
